import { Injectable } from "@angular/core";
import { UTCDate, PaletteDescriptor, InterpolationService } from "map-wald";
import { TerrakioLayerMin } from "./terrakio-layer";

const TIME_PARAMETER_ORDER=[
  'year',
  'month',
  'delta_month'
];

@Injectable()
export class WMSClientService {
  constructor() { }

  expressionForDate(layer: TerrakioLayerMin, date: UTCDate): string {
    const timeRequest = indexExpression(date);
    return expressionForTimeRequest(layer,timeRequest);
  }

}

export function expressionForTimeRequest(layer: TerrakioLayerMin, timeRequest: string): string {
  if(layer.script){
    return (layer.shortVariable||layer.variable);
    // const expression = (layer.shortVariable||layer.variable);
    // const params = {
    //   timeRequest,
    //   requestVariable: layer.shortVariable||layer.variable
    // };
    // return InterpolationService.interpolate(expression,params);
  }
  return `${layer.collection}.${layer.shortVariable||layer.variable}${timeRequest}`;
}

function pad(n: number,digits?: number): string{
  digits = digits || 2;

  let result = n.toString();
  while (result.length<digits){
    result = '0' + result;
  }
  return result;
}

export function indexExpression(d: UTCDate):string {
  return timeParameterExpression({
    year: d.getUTCFullYear(),
    month: d.getUTCMonth()+1
  });
}

export function timeParameterExpression(params:any):string {
  const terms:string[] = TIME_PARAMETER_ORDER.filter(p=>params[p]).map(k=>{
    const v = params[k];
    if(v.length){
      if(v.length===1){
        return `${k}=${v[0]}`;
      }
      return `${k}=(${v.join(',')})`;
    }
    return `${k}=${v}`;
  });
  return '@(' + terms.join(',') + ')';
}

export function formatDate(d: UTCDate):string {
  return `${d.getUTCFullYear()}-${pad(d.getUTCMonth()+1)}-01T00:00:00Z`;
}

export function cbPaletteName(palette: PaletteDescriptor):string {
  const rev = palette.reverse?'_r':'';
  return `${palette.name}_${palette.count}${rev}`;
}
